/* eslint-disable no-extend-native */
// Polyfills pour iOS < 14 et Safari ancien
import 'core-js/stable';

// Polyfill pour String.prototype.replaceAll
if (!String.prototype.replaceAll) {
  String.prototype.replaceAll = function(search, replace) {
    return this.split(search).join(replace);
  };
}

// Polyfill pour Array.prototype.at
if (!Array.prototype.at) {
  Array.prototype.at = function(index) {
    const idx = index >= 0 ? index : this.length + index;
    return this[idx];
  };
}

// Polyfill pour String.prototype.at
if (!String.prototype.at) {
  String.prototype.at = function(index) {
    const idx = index >= 0 ? index : this.length + index;
    return this[idx];
  };
}

// Polyfill pour Object.hasOwn (déjà dans index.html mais on le garde ici aussi)
if (!Object.hasOwn) {
  Object.hasOwn = function(obj, prop) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
  };
}

// Polyfill pour l'opérateur ??= (logical nullish assignment)
// Note: Ceci ne peut pas être polyfillé directement,
// mais on peut s'assurer que Babel le transpile correctement